





















































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import addNode from "@/components/addNode/index.vue";
import addBranchEnd from "@/components/node/add-branch-end.vue";
import {UserModule} from "@/store/modules/user";
import { getDeparmentList, getMarketCooperationPrevLevel } from '@/api/common'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

Vue.directive('el-select-loadmore', { // 指令懒加载
  // bind表示这个自定义指令一绑定到dom上，就开始自动执行
  bind(el: any, binding: any) {
    // 获取element-ui定义好的scroll盒子
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
    SELECTWRAP_DOM.addEventListener('scroll', function () {
      /**
       * scrollHeight 获取元素内容高度(只读)
       * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
       * clientHeight 读取元素的可见高度(只读)
       * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
       * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
       */
      const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
      if (condition) {
        binding.value();
      }
    });
  },
  // 表示dom插入到页面上的时候自动执行
  // 这些函数都有两个参数，一个是el(使用自定义指令的元素), 一个是binding(记录自定义指令信息的对象)
  inserted(el, binding) {
    el.focus()
  },
  // 表示自定义指令后面的值更新的时候，自动执行
  update() {
    // console.log(this.scrollHeight , this.scrollTop, '11');
  }
})
@Component({
  components: {addBranchEnd, addNode,MoreUsersFilter},
})
export default class AddNode extends Vue {
  /*
    nodeInfo 字段含义
    approvalPersonType   按职级审批  1职级 0审批
    approvalType  多人或签、单人审批  1单人审批  0 多人或签
    approvalPerson  不管是指定人审批，还是按职级审批   全部放在这里面
    children  后面是否还有节点
    conditions  当前节点是否有条件分支，条件分支优先于审核人
    editFile  可编辑字段
    types 当前节点的类型  1审核 0 抄送
     */
  // ------ 变量 ------
  drawerShow = false;
  conditionFile = ""; // 选择添加条件字段
  conditionCnFile = ""; // 选择添加条件字段
  selectCondition = ""; // 选择的触发条件
  conditionFileValue = ""; // 输入的条件值
  conditionCnFileValue = "";
  index = 0;
  selectConditionList = []; // 条件数组
  rangeList = []; // 范围选择
  conditionPriority: number = null; // 条件优先级
  marketCooperation = []
  marketLevelPage = 1
  marketLevelSize = 20
  cooperativePartnerName = ''
  newCnConditionList = []
  conditionFileValueIdList = []
  newconditionFileValue = []
  partnerValue = "" // 绑定的合作伙伴的值
  deparmentList: any = [] // 部门列表
  userList = [] //输入范围为人员时候的值
  userNameList = []

  get conditionPriorityList() {
    const arr: { val: number; name: string }[] = [];
    for (let i = 0; i < this.conditions.length - 1; i++) {
      arr.push({val: i + 1, name: "优先级" + (i + 1)});
    }
    arr.push({val: 0, name: "默认流程"});
    return arr;
  }

  // props
  @Prop() transmitConditions!: any;


  // 已经被其他条件节点选择过的优先级
  get selectionConditionPriority() {
    const obj = this.conditions[this.index];
    const arr: number[] = this.conditions
        .map((item) => item.priority)
        .filter((item) => item);
    if (this.conditions.filter((item) => item.priority === 0)[0]) arr.push(0);
    return arr;
  }

  // get userList() {
  //   return UserModule.userList;
  // }

  // get deparmentList() {
  //   return UserModule.deparmentList;
  // }

  // ------ prop ------
  @Prop() conditions!: any;
  @Prop() nodeInfo!: any;
  @Prop() editFileList!: any; // 可编辑字段列表
  @Prop() approvalPersonTypeList!: any; // 审批类型列表
  @Prop() approvalPersonList!: any; // 可选职级列表
  @Prop() approvalTypeList!: any; // 审批人类型  单人、多人
  @Prop() conditionFileList!: any;

  // ------ 生命周期 ------
  created() {
    // this.getMarketCooperationPrevLevel()
    this.getDeparmentList()
  }


  // ------ 方法 ------
  // 获取部门列表(登录后初始调用公共数据)
  async getDeparmentList() {
    const data = (await getDeparmentList()) as any;
    this.deparmentList = data

  }
  addBranch() {
    const data = {
      priority: "",
      conditionsFile: "",
      condition: "",
      conditionList: [],
      conditionValue: [],
      nodeObject: {},
    };
    this.conditions.push(data);
  }

  delBranch(index: number) {
    this.conditions.splice(index, 1);
  }

  clickBranch(item: any, index: number) {
    this.index = index;
    this.conditionFile = item.conditionFile;
    this.conditionCnFile = item.conditionCnFile;
    this.selectCondition = item.condition;
    this.conditionFileValue =
        item.conditionValue && item.conditionValue.length === 1
            ? item.conditionValue[0]
            : item.conditionValue;
    this.conditionCnFileValue = item.conditionCnValue;
    this.conditionPriority = item.priority;
    // 编辑数据回显
    if (this.conditionFile == 'marketCooperationId') { // 关联上级
      if (item.conditionValue && item.conditionCnValue) {
        this.partnerValue = item.conditionValue.map((id, i) => ({id, name: item.conditionCnValue.split(',')[i]}))
        const newSelectList = item.conditionValue.map((id, i) => ({id, name: item.conditionCnValue.split(',')[i]}))
        this.marketCooperation = this.marketCooperation.concat(newSelectList)
      }
    } else if (this.conditionFile === "createdUserId") { // 创建人
      this.conditionFileValue = item.conditionValue
    }
    //  如果符合条件 为人员 输入范围回显 （ && this.rangeList.length>0 && this.rangeList[0].zhRange === '全体员工' ）
    if (this.conditionFileValue && this.conditionFileValue.length > 0 && (this.conditionFile === "createdUserId" || this.conditionFile === "directorUserId" || this.conditionFile === 'marketCooperationDirectorUserId' || this.conditionFile === "userId")) {

      let flag = true;
      (this.conditionFileValue as any).forEach(jkme => {
        if (!jkme.userId) {
          flag = false;
        }
      })
      if (flag) {
        //  编辑
        this.userNameList = (this.conditionFileValue as any).map(item => ({
          id: item.userId ? item.userId : item,
          realName: item.userRealName ? item.userRealName : null,
          departmentName: item.userDepartmentName ? item.userDepartmentName : null,
        }))
        this.userList = item.conditionValue.map(item => item.userId)
      } else {
        //   新建
        this.userNameList = (this.conditionFileValue as any).map((id, i) => ({
          id,
          realName: this.conditionCnFileValue.split(',')[i]
        }))
        this.userList = this.conditionFileValue as any
      }
    }

    if (this.conditionFile) {
      this.selectConditionList = this.conditionFileList.filter(
          (item) => item.enFile === this.conditionFile
      )[0].conditionList;
      this.rangeList = this.conditionFileList.filter(
          (item) => item.enFile === this.conditionFile
      )[0].rangeList;
      this.conditionCnFile = this.conditionFileList.filter(
          (item) => item.enFile === this.conditionFile
      )[0].zhFile;
    } else {
      this.rangeList = []
    }
    this.conditionPriority = item.priority;
    this.drawerShow = true;
  }

  drawerClose(done: any) {

    this.conditionFileList.forEach((item: any) => {
      if (item.cnFile == this.conditionFile)
        this.conditions[this.index].conditionFile = item.file;
    });
    this.conditions[this.index].conditionFile = this.conditionFile;
    this.conditions[this.index].conditionCnFile = this.conditionCnFile;
    this.conditions[this.index].condition = this.selectCondition;


    // 如果是上级合作伙伴
    if (this.conditionFile == 'marketCooperationId') {
      if (this.conditionCnFileValue) {
        this.conditionFileValue = (this.partnerValue as any).map(item => item.id) as any

      } else {
        this.conditionFileValue = ''
        this.partnerValue = ''
      }
    }
    this.conditions[this.index].conditionValue =
        typeof this.conditionFileValue === "object"
            ? this.conditionFileValue
            : this.conditionFileValue ? [this.conditionFileValue] : [];
    this.conditions[this.index].conditionCnValue = this.conditionCnFileValue;
    this.conditions[this.index].priority = this.conditionPriority;
    if (this.conditions[this.index].priority === 0) {
      delete this.conditions[this.index].conditionFile;
      delete this.conditions[this.index].conditionCnFile;
      delete this.conditions[this.index].condition;
      delete this.conditions[this.index].conditionValue;
      delete this.conditions[this.index].conditionCnValue;
    }
    this.partnerValue = ''
    done();
  }

  conditionFileChange() {
    this.selectConditionList = this.conditionFileList.filter(
        (item) => item.enFile === this.conditionFile
    )[0].conditionList;
    this.rangeList = this.conditionFileList.filter(
        (item) => item.enFile === this.conditionFile
    )[0].rangeList;
    this.conditionCnFile = this.conditionFileList.filter(
        (item) => item.enFile === this.conditionFile
    )[0].zhFile;
    this.selectCondition = "";
    this.conditionFileValue = "";
    this.partnerValue = ""
    //  切换的时候清空人员列表
    this.userList = []
    this.userNameList = []
  }


  changeUsers(e) {
    this.userList = e.id
    this.userNameList = e.array
    // this.conditionFileValue = e.array.map(item => item.id)
    this.conditionFileValue = e.id
    this.conditionCnFileValue = e.array
        .map((item) => item.realName)
        .join("，");
    this.conditionFileValueChange(e.id)
  }

  conditionFileValueChange(val) {
    if (this.rangeList.length === 0) {
      this.conditionCnFileValue = this.conditionFileValue;
    } else if (this.rangeList[0].zhRange === "全体员工") {
      // const newArr = this.userList.filter((item) =>
      //     this.conditionFileValue.includes(item.id)
      // );
      // this.conditionCnFileValue = newArr
      //     .map((item) => item.realName)
      //     .join("，");
    } else if (this.rangeList[0].zhRange === "全部部门") {
      // eslint-disable-next-line no-inner-declarations
      const valArr = this.conditionFileValue;

      // eslint-disable-next-line no-inner-declarations
      function fun(arr, valArr) {
        const names = [];
        const valArrStr = valArr.map(String);
        arr.forEach((item) => {
          if (valArrStr.includes(String(item.id))) {
            names.push(item.name);
          }
          // 递归子节点，把子节点结果合并进来
          if (item.children && item.children.length > 0) {
            const childNames = fun(item.children, valArr);
            if (childNames) {
              names.push(...childNames.split('，'));
            }
          }
        });
        return names.join('，');
      }

      this.conditionCnFileValue = fun(this.deparmentList, valArr);
    } else if (this.rangeList[0].zhRange === '所有合作伙伴') {

      this.conditionFileValueIdList = []
      this.newCnConditionList = []
      if (val && val.length > 0) {
        const val1 = val.filter(item => item.id)
        // this.addMarketSelectList = val1
        val1.map(item => {
          this.conditionFileValueIdList.push(item.id)
          this.newCnConditionList.push(item.name)
          this.newconditionFileValue = this.conditionFileValueIdList
          this.conditionCnFileValue = this.newCnConditionList.join(',')
        })
      }

    } else {
      this.conditionCnFileValue = this.rangeList.filter(
          (item) => item.cnRange === this.conditionFileValue
      )[0].zhRange;
    }
  }

  async getMarketCooperationPrevLevel() {

    const data: any = await getMarketCooperationPrevLevel(
        {
          page: this.marketLevelPage,
          limit: this.marketLevelSize,
          name: this.cooperativePartnerName
        }
    )

    this.marketCooperation = [...this.marketCooperation, ...data.marketCooperationList]

    const result = []
    const obj = {}
    for (let i = 0; i < this.marketCooperation.length; i++) {
      if (!obj[this.marketCooperation[i].id]) {
        result.push(this.marketCooperation[i]);
        obj[this.marketCooperation[i].id] = true;
      }
    }
    this.marketCooperation = result
  }


  async remoteCooperativePartnerMethod(query: any) {
    this.cooperativePartnerName = query
    this.marketLevelPage = 1
    this.marketLevelSize = 20
    if (query !== '') {
      const result: any = await getMarketCooperationPrevLevel(
          {
            page: this.marketLevelPage,
            limit: this.marketLevelSize,
            name: query
          })

      this.marketCooperation = result.marketCooperationList

    }
  }


  clearCooperativePartner() {
    this.marketCooperation = []
    this.cooperativePartnerName = null
    this.marketLevelPage = 1
    this.marketLevelSize = 20
    this.getMarketCooperationPrevLevel()
  }

  cooperativePartnerLoadmore() {
    this.marketLevelPage = 1
    this.marketLevelSize += 20
    this.getMarketCooperationPrevLevel();
  }
  // focus
  async handleCondition() {

    if ((this.marketCooperation.length == 0 || !this.cooperativePartnerName) && !this.partnerValue) {
      this.cooperativePartnerName = null
      this.marketLevelPage = 1
      this.marketLevelSize = 20
      const result: any = await getMarketCooperationPrevLevel({
        page: this.marketLevelPage,
        limit: this.marketLevelSize,
        name: this.cooperativePartnerName
      })

      this.marketCooperation = result.marketCooperationList
    }

    if (this.partnerValue && this.partnerValue.length > 0) {
      this.marketCooperation = []
      this.cooperativePartnerName = null
      this.marketLevelPage = 1
      this.marketLevelSize = 20
      const result: any = await getMarketCooperationPrevLevel(
          {
            page: this.marketLevelPage,
            limit: this.marketLevelSize,
            name: this.cooperativePartnerName
          })

      this.marketCooperation = result.marketCooperationList
    }
  }

  // ------ 监听 ------
  @Watch("nodeInfo", {deep: true})
  watchNodeInfo(val: any) {
    this.$emit("update:nodeInfo", val);
  }

  // 选择关联上级之后
  @Watch('conditionFile', {deep: true})
  WatchConditionFile(val: any) {
    if (val == 'marketCooperationId') {
      this.getMarketCooperationPrevLevel()
    }
  }

  @Watch('cooperativePartnerName', {deep: true})
  WatchCooperativePartnerName(val: any) {
    if (val == '') {
      this.marketCooperation = []
      this.marketLevelPage = 1
      this.marketLevelSize = 20
      this.getMarketCooperationPrevLevel()
    }
  }
}
